import type { DraftState } from '@upright/common/mcp-payloads/financial-statement-import';
import type { GetSingleCompanyFinancialStatementResponse } from '@upright/common/model/input/financial-statements/api-types';

/** Overlay stored figures while retaining extraction context for unchanged cells. */
export function refreshFinancialStatementDraft(
  draft: DraftState,
  statement: Pick<GetSingleCompanyFinancialStatementResponse, 'id' | 'companyId' | 'currency' | 'endDate'> & {
    inputValues: NonNullable<GetSingleCompanyFinancialStatementResponse['inputValues']>;
  },
): DraftState {
  if (String(statement.id) !== draft.draftId || statement.companyId !== draft.companyId) return draft;
  const sections: Partial<Record<string, Record<string, number | null | undefined>>> = {
    IS: statement.inputValues.incomeStatement,
    BS: statement.inputValues.balanceSheet,
    CF: statement.inputValues.cashFlowStatement,
  };
  const cells = { ...draft.cells };
  for (const [key, cell] of Object.entries(cells)) {
    const [prefix, field] = key.split('.');
    const value = sections[prefix]?.[field] ?? null;
    if (value === cell.value) continue;
    cells[key] = {
      cellKey: key,
      value,
      state: value === null ? 'gap' : 'filled',
      resolvedBy: 'user-chat',
    };
  }
  return { ...draft, cells, currency: statement.currency, periodEnd: statement.endDate.slice(0, 10) };
}
